import React from 'react';
import QuestionMark from '../images/question.png'
import { Link } from 'react-router'
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
  breadcrumbContainer: {
    alignItems: 'center',
    fontSize: '15px',
    color: '#475569',
    padding: '8px 20px',
    fontFamily: "'Inter', -apple-system, sans-serif",
    fontWeight: 500,
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      fontSize: '13px',
      padding: '6px 12px',
    },
  },
  link: {
    textDecoration: 'none',
    color: '#2563eb',
    marginRight: '4px',
    marginLeft: '4px',
    fontWeight: 500,
    transition: 'color 0.15s ease',
    '&:hover': { color: '#1d4ed8' },
    [theme.breakpoints.down('sm')]: {
      marginRight: '3px',
      marginLeft: '3px',
    },
  },
  questionMark: {
    height: '20px',
    width: '20px',
    marginLeft: '8px',
    opacity: 0.6,
    transition: 'opacity 0.15s ease',
    '&:hover': { opacity: 1 },
    [theme.breakpoints.down('sm')]: {
      height: '16px',
      width: '16px',
      marginLeft: '4px',
    },
  },
});

class BreadCrumb extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      hover: false
    }
  }
  render() {
    const { classes } = this.props;
    const pathname = window.location.pathname;

    return (
      <div className="zaps-breadcrumb-bar">
        {pathname === '/' && <div>
          Login
         </div>}
        {pathname === '/home' && <div>
          Dashboard
                    <a href='https://sites.google.com/zolostays.com/helpdesk/home/zaps/overview?authuser=0' target="_blank">
            <img src={QuestionMark} className={classes.questionMark} alt="Help" />
          </a>
        </div>}
        {pathname === '/vendor/onboard' &&
          <div>
            <Link to='/home' className={classes.link} >Dashboard </Link>
            <span style={{ color: '#cbd5e1', margin: '0 4px' }}>/</span><span>Vendor Onboarding</span>
            <a href='https://sites.google.com/zolostays.com/helpdesk/home/zaps/vendor-onboarding?authuser=0' target="_blank">
              <img src={QuestionMark} className={classes.questionMark} alt="Help" />
            </a>
          </div>}
        {pathname === '/vendor/approved' &&
          <div>
            <Link to='/home' className={classes.link} >Dashboard </Link>
            <span style={{ padding: '10px' }}>    / </span><span>Verified Vendors</span>
            <a href='https://sites.google.com/zolostays.com/helpdesk/home/zaps/verified-vendors?authuser=0' target="_blank">
              <img src={QuestionMark} className={classes.questionMark} alt="Help" />
            </a>
            </div>}
        {pathname === '/vendor/pending/edit' &&
          <div>
            <Link to='/home' className={classes.link}>Dashboard </Link>
            <span style={{ padding: '10px' }}>    / </span>
            <Link to='/vendor/pending' className={classes.link}>Pending Vendors</Link>
            <span style={{ padding: '10px' }}>    / </span>
            <span >Edit</span>
          </div>}
        {pathname === '/vendor/approved/edit' &&
          <div>
            <Link to='/home' className={classes.link}>Dashboard </Link>
            <span style={{ padding: '10px' }}>    / </span>
            <Link to='/vendor/approved' className={classes.link}>Verified Vendor</Link>
            <span style={{ padding: '10px' }}>    / </span>
            <span >Edit</span>
          </div>}
        {pathname === '/vendor/pending/info' &&
          <div>
            <Link to='/home' className={classes.link}>Dashboard </Link>
            <span style={{ padding: '10px' }}>    / </span>
            <Link to='/vendor/pending' className={classes.link}>Pending Vendors </Link>
            <span style={{ padding: '10px' }}>    / </span>
            <span >Info</span>
          </div>}
        {pathname === '/vendor/approved/info' &&
          <div>
            <Link to='/home' className={classes.link}>Dashboard </Link>
            <span style={{ padding: '10px' }}>    / </span>
            <Link to='/vendor/approved' className={classes.link}>Verified Vendors</Link>
            <span style={{ padding: '10px' }}>    / </span>
            <span >Info</span>
          </div>}
        {pathname === '/vendor/approval' &&
          <div>
            <Link to='/home' className={classes.link}>Dashboard </Link>
            <span style={{ padding: '10px' }}>    / </span>
            <span >  Approve Vendors </span>
            <a href='https://sites.google.com/zolostays.com/helpdesk/home/zaps/approve-vendors?authuser=0' target="_blank">
              <img src={QuestionMark} className={classes.questionMark} alt="Help" />
            </a>
          </div>}
        {pathname === '/vendor/pending' &&
          <div>
            <Link to='/home' className={classes.link}>Dashboard </Link>
            <span style={{ padding: '10px' }}>    / </span>
            <span>  Pending Vendors </span>
            <a href='https://sites.google.com/zolostays.com/helpdesk/home/zaps/pending-vendors?authuser=0' target="_blank">
              <img src={QuestionMark} className={classes.questionMark} alt="Help" />
            </a>
          </div>}
        {pathname === '/vendor/approval-preview' &&
          <div>
            <Link to='/home' className={classes.link}>Dashboard </Link>
            <span style={{ padding: '10px' }}>    / </span>
            <Link to='/vendor/approval' className={classes.link}>Approve Vendors</Link>
            <span style={{ padding: '10px' }}>    / </span>
            <span style={{ padding: '10px' }}> Preview </span>
          </div>}
        {pathname === '/payment/request' &&
          <div>
            <Link to='/home' className={classes.link}>Dashboard </Link>
            <span style={{ padding: '10px' }}>    / </span>
            <Link to='/initializePR' className={classes.link}>Payment Request</Link>
            <span style={{ padding: '10px' }}>    / </span>
            <span> Create</span>
            <a href='https://sites.google.com/zolostays.com/helpdesk/home/zaps/pending-vendors?authuser=0' target="_blank">
              <img src={QuestionMark} className={classes.questionMark} alt="Help" />
            </a>
          </div>}
        {pathname === '/vendor/payment/approve' &&
          <div>
            <Link to='/home' className={classes.link}>Dashboard </Link>
            <span style={{ padding: '10px' }}>    / </span>
            <span >Approve Payments</span>
            <a href='https://sites.google.com/zolostays.com/helpdesk/home/zaps/pending-vendors?authuser=0' target="_blank">
              <img src={QuestionMark} className={classes.questionMark} alt="Help" />
            </a>
          </div>}
        {pathname === '/vendor/payment/approved' &&
          <div>
            <Link to='/home' className={classes.link}>Dashboard </Link>
            <span style={{ padding: '10px' }}>    / </span>
            <span >Processed Payments</span>
            <a href='https://sites.google.com/zolostays.com/helpdesk/home/zaps/pending-vendors?authuser=0' target="_blank">
              <img src={QuestionMark} className={classes.questionMark} alt="Help" />
            </a>
          </div>}
        {pathname === '/vendor/payment/pending' &&
          <div>
            <Link to='/home' className={classes.link}>Dashboard </Link>
            <span style={{ padding: '10px' }}>    / </span>
            <span >Pending Payments</span>
            <a href='https://sites.google.com/zolostays.com/helpdesk/home/zaps/pending-vendors?authuser=0' target="_blank">
              <img src={QuestionMark} className={classes.questionMark} alt="Help" />
            </a>
          </div>}
        {pathname === '/vendor/payment/approve/preview' &&
          <div>
            <Link to='/home' className={classes.link}>Dashboard </Link>
            <span style={{ padding: '10px' }}>    / </span>
            <Link to="/vendor/payment/approve" style={{ padding: '10px', textDecoration: 'none' }}>  Approve Payments </Link>
            <span style={{ padding: '10px' }}>    / </span>
            <span style={{ padding: '10px' }}>Preview</span>
          </div>}
        {pathname === '/vendor/payment/approved/preview' &&
          <div>
            <Link to='/home' className={classes.link}>Dashboard </Link>
            <span style={{ padding: '10px' }}>    / </span>
            <Link to="/vendor/payment/approved" style={{ padding: '10px', textDecoration: 'none' }}>  Processed Payments </Link>
            <span style={{ padding: '10px' }}>    / </span>
            <span style={{ padding: '10px' }}>Preview</span>
          </div>}
        {pathname === '/vendor/payment/pending/preview' &&
          <div>
            <Link to='/home' className={classes.link}>Dashboard </Link>
            <span style={{ padding: '10px' }}>    / </span>
            <Link to="/vendor/payment/pending" style={{ padding: '10px', textDecoration: 'none' }}>  Pending Payments </Link>
            <span style={{ padding: '10px' }}>    / </span>
            <span style={{ padding: '10px' }}>Preview</span>
          </div>}
        {pathname === '/payment/request/edit' &&
          <div>
            <Link to='/home' className={classes.link}>Dashboard </Link>
            <span style={{ padding: '10px' }}>    / </span>
            <Link to="/vendor/payment/pending" style={{ padding: '10px', textDecoration: 'none' }}>  Pending Payments </Link>
            <span style={{ padding: '10px' }}>    / </span>
            <span style={{ padding: '10px' }}>Edit</span>
          </div>}
        {pathname === '/vendor/payment/init' &&
          <div>
            <Link to='/home' className={classes.link}>Dashboard </Link>
            <span style={{ padding: '10px' }}>    / </span>
            <span >Payments Intialized</span>
            <a href='https://sites.google.com/zolostays.com/helpdesk/home/zaps/pending-vendors?authuser=0' target="_blank">
              <img src={QuestionMark} className={classes.questionMark} alt="Help" />
            </a>
          </div>}
        {pathname === '/vendor/payment/init/preview' &&
          <div>
            <Link to='/home' className={classes.link}>Dashboard </Link>
            <span style={{ padding: '10px' }}>    / </span>
            <Link to="/vendor/payment/init" style={{ padding: '10px', textDecoration: 'none' }}>  Payments Intialized </Link>
            <span style={{ padding: '10px' }}>    / </span>
            <span style={{ padding: '10px' }}>Preview</span>
          </div>}
        {pathname === '/payment/generated_buf' &&
          <div>
            <Link to='/home' className={classes.link}>Dashboard </Link>
            <span style={{ padding: '10px' }}>    / </span>
            <span >Generated BUF</span>
            <a href='https://sites.google.com/zolostays.com/helpdesk/home/zaps/pending-vendors?authuser=0' target="_blank">
              <img src={QuestionMark} className={classes.questionMark} alt="Help" />
            </a>
          </div>}
        {/* {pathname === '/vendor/payment/success' &&
          <div>
            <Link to='/home' className={classes.link}>Dashboard </Link>
            <span style={{ padding: '10px' }}>    / </span>
            <span >Pending Successful</span>
            <a href='https://sites.google.com/zolostays.com/helpdesk/home/zaps/pending-vendors?authuser=0' target="_blank">
              <img src={QuestionMark} className={classes.questionMark} alt="Help" />
            </a>
          </div>}
        {pathname === '/vendor/payment/failure' &&
          <div>
            <Link to='/home' className={classes.link}>Dashboard </Link>
            <span style={{ padding: '10px' }}>    / </span>
            <span >Pending Failure</span>
            <a href='https://sites.google.com/zolostays.com/helpdesk/home/zaps/pending-vendors?authuser=0' target="_blank">
              <img src={QuestionMark} className={classes.questionMark} alt="Help" />
            </a>
          </div>} */}
        {pathname === '/cost-center/add' &&
          <div>
            <Link to='/home' className={classes.link}>Dashboard </Link>
            <span style={{ padding: '10px' }}>    / </span>
            <span >Add Cost Center</span>
            {/* <a href='https://sites.google.com/zolostays.com/helpdesk/home/zaps/pending-vendors?authuser=0' target="_blank">
              <img src={QuestionMark} className={classes.questionMark} alt="Help" />
            </a> */}
          </div>}
          {pathname === '/cost-center/view' &&
          <div>
            <Link to='/home' className={classes.link}>Dashboard </Link>
            <span style={{ padding: '10px' }}>    / </span>
            <span >View Cost Center</span>
          </div>}
          {pathname === '/payment/status' &&
          <div>
            <Link to='/home' className={classes.link}>Dashboard </Link>
            <span style={{ padding: '10px' }}>    / </span>
            <span >Payment Status</span>
          </div>}
          {pathname === '/payment/buf-rejected' &&
          <div>
            <Link to='/home' className={classes.link}>Dashboard </Link>
            <span style={{ padding: '10px' }}>    / </span>
            <span >BUF Rejected Payments</span>
          </div>}
          {pathname === '/users' &&
          <div>
            <Link to='/home' className={classes.link}>Dashboard </Link>
            <span style={{ padding: '10px' }}>    / </span>
            <span >Add Users</span>
          </div>}
          {pathname === '/initializePR' &&
          <div>
            <Link to='/home' className={classes.link}>Dashboard </Link>
            <span style={{ padding: '10px' }}>    / </span>
            <span >Payment Request</span>
            <a href='https://sites.google.com/zolostays.com/helpdesk/home/zaps/payment-request?authuser=0' target="_blank">
              <img src={QuestionMark} className={classes.questionMark} alt="Help" />
            </a>
          </div>}
          {pathname === '/bulkPreview' &&
          <div>
            <Link to='/home' className={classes.link}>Dashboard </Link>
            <span style={{ padding: '10px' }}>    / </span>
            <Link to='/initializePR' className={classes.link}>Payment Request</Link>
            <span style={{ padding: '10px' }}>    / </span>
            <span> Bulk Preview</span>
          </div>}
          {pathname === '/payment/reports' &&
          <div>
            <Link to='/home' className={classes.link}>Dashboard </Link>
            <span style={{ padding: '10px' }}>    / </span>
            <span >Reports</span>
          </div>}
          {pathname === '/payment/paymentsReport' &&
          <div>
            <Link to='/home' className={classes.link}>Dashboard </Link>
            <span style={{ padding: '10px' }}>    / </span>
            <Link to='/payment/reports' className={classes.link}>Reports</Link>
            <span style={{ padding: '10px' }}>    / </span>
            <span> Payments Report Generation</span>
          </div>}
          {pathname === '/payment/accountingReport' &&
          <div>
            <Link to='/home' className={classes.link}>Dashboard </Link>
            <span style={{ padding: '10px' }}>    / </span>
            <Link to='/payment/reports' className={classes.link}>Reports</Link>
            <span style={{ padding: '10px' }}>    / </span>
            <span> Accounting Report Generation</span>
          </div>}
          {pathname === '/payment/billSubmissionReport' &&
          <div>
            <Link to='/home' className={classes.link}>Dashboard </Link>
            <span style={{ padding: '10px' }}>    / </span>
            <Link to='/payment/reports' className={classes.link}>Reports</Link>
            <span style={{ padding: '10px' }}>    / </span>
            <span> Bill Submission Report Generation</span>
          </div>}
          {pathname === '/payment/provisionReport' &&
          <div>
            <Link to='/home' className={classes.link}>Dashboard </Link>
            <span style={{ padding: '10px' }}>    / </span>
            <Link to='/payment/reports' className={classes.link}>Reports</Link>
            <span style={{ padding: '10px' }}>    / </span>
            <span> Provision Report Generation</span>
          </div>}
          {pathname === '/payment/payment-request-preview' && (
            <div>
            <Link to='/home' className={classes.link}>Dashboard </Link>
            <span style={{ padding: '10px' }}>    / </span>
            <span> Payment Request Preview</span>
          </div>
          )}
          {pathname === '/payment/payment-request-preview/timeline' && (
            <div>
              <Link to='/home' className={classes.link}>Dashboard </Link>
              <span style={{ padding: '10px' }}>    / </span>
              <span> Payment Request Timeline</span>
            </div>
          )}
          {pathname === '/payment/tally-excel-upload' && (
            <div>
              <Link to='/home' className={classes.link}>Dashboard </Link>
              <span style={{ padding: '10px' }}>    / </span>
              <Link to='/payment/reports' className={classes.link}>Reports</Link>
              <span style={{ padding: '10px' }}>    / </span>
              <span> Tally Excel Upload</span>
            </div>
          )}
          {pathname === '/cities' &&
          <div>
            <Link to='/home' className={classes.link}>Dashboard </Link>
            <span style={{ padding: '10px' }}>    / </span>
            <span >City Management</span>
          </div>}
          {pathname === '/business-units' &&
          <div>
            <Link to='/home' className={classes.link}>Dashboard </Link>
            <span style={{ padding: '10px' }}>    / </span>
            <span >Business Unit Management</span>
          </div>}
      </div>
    )
  }
}

export default withStyles(styles)(BreadCrumb);


// WEBPACK FOOTER //
// ./src/components/BreadCrumb.js